import React from 'react';

import {humanEnumeration} from '../../../../components/utils';
import {useCharacter} from '../character-context';
import {armorLabel, weaponLabel} from '../model/labels';
import {Fact, SheetBlock} from './sheet-block';

import css from './sheet.module.css';

export const ProficienciesBlock: React.FC = () => {
	const {catalog, character} = useCharacter();
	const itemTitle = (itemId: string) => catalog.getItem(itemId)?.title || itemId;
	const languageTitle = (languageId: string) => catalog.getLanguage(languageId)?.title || languageId;

	const facts: [string, string[]][] = [
		['Обращение с бронёй', character.armorProficiencies.map(armorLabel)],
		['Умения в оружии', character.weaponProficiencies.map(weaponLabel)],
		['Оружейное мастерство', character.weaponMasteries.map(itemTitle)],
		[
			'Умения в инструментах',
			[...character.toolProficiencies, ...character.instrumentProficiencies].map(itemTitle),
		],
		['Языки', character.languages.map(languageTitle)],
	];
	const filledFacts = facts.filter(([, values]) => values.length);

	if (!filledFacts.length) return null;

	return (
		<SheetBlock title="Умения" card>
			<dl className={css.facts}>
				{filledFacts.map(([label, values]) => (
					<Fact key={label} label={label}>
						{humanEnumeration(values)}
					</Fact>
				))}
			</dl>
		</SheetBlock>
	);
};
